import React, { FunctionComponent } from 'react';
import Slider from 'react-slick'
import { useSlickReady } from '../../../hooks/useSlickReady'
import { RelatedEvent } from '../../../types/eventDetail';
import { ContentCard } from '../../molecules/contentCard';

type Props = {
  events: RelatedEvent[];
};

export const Presentation: FunctionComponent<Props> = ({ events }) => {
  const ready = useSlickReady(events.length > 0)

  if (events.length === 0) return null;

  const isMobile = window.innerWidth <= 780;
  const settings = {
    dots: isMobile,
    infinite: true,
    speed: 300,
    slidesToShow: isMobile ? 1 : 4,
    slidesToScroll: isMobile ? 1 : 1,
    arrows: !isMobile,
    responsive: [
      {
        breakpoint: 780,
        settings: {
          arrows: false,
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  }

  return (
    <aside className="l-related-articles p-related-articles">
      <h2 className="p-related-articles__heading p-related-articles__heading--border">
        開催日の近いイベント
      </h2>
      <div className="p-related-articles__inner">
        {ready && (
          <Slider {...settings} className='p-related-articles__list'>
            {events.map(event => (
              <div key={event.id}>
                <ContentCard
                  id={event.id}
                  title={event.title}
                  companyName={event.companyName}
                  companyIcon={event.companyIcon}
                  image={event.image}
                  type="event"
                />
              </div>
            ))}
          </Slider>
        )}
      </div>
      <div className="p-related-articles__readmore p-related-articles__readmore--pc">
        <a href="/events" data-event="click" data-category="eventcontent" data-value="more_related_events">
          READ MORE...
        </a>
      </div>
      <div className="p-related-articles__readmore p-related-articles__readmore--sp">
        <a href="/events" data-event="click" data-category="eventcontent" data-value="more_related_events">
          もっとみる
        </a>
      </div>
    </aside>
  );
};
